<template>
  <v-container fluid grid-list-lg>
		<v-layout row wrap>
			<v-flex xs12 sm6 offset-sm3>
				<v-card>
          <v-container>
            <form>
              <v-layout>
              <input type="file" ref="filename" accept="*.pdf">             
              </v-layout>
              <v-layout row wrap>
                <v-btn
                  @click="change"
                  color="blue-grey"
                  class="success"
                >
                  Upload
                  <v-icon right dark>cloud_upload</v-icon>
                </v-btn> 
              </v-layout>
            </form>
          </v-container>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
import firebase from 'firebase'
// import { eventBus } from '../Eventbus/eventbus'
export default {
  data: function () {
    return {
      file_name: '',
      loader: null,
      loading3: false,
      uploadTask: ''
    }
  },
  methods: {
    change: function () {
      this.file_name = this.$refs.filename.files[0]
      this.uploadTask = firebase.storage().ref('/Weekly-Update')
      this.uploadTask.put(this.file_name)
      .then(function (snapshot) {
        var url = snapshot.downloadURL
        var updates = {}
        updates['WeeklyUpdate/url'] = url
        return firebase.database().ref().update(updates)
      },
      function (error) {
        console.log(error)
      })
      // return this.$router.push('/')
    }
  }
}
</script>
<style>
.success {
  align-self: center;
}
.container.grid-list-lg {
  padding: 0px;
  overflow: hidden;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// Update.vue?07be4776